'use client'
import { useNameScopeValidation } from '@/app/_hooks/useNameScopeValidation'

export function NameScopeControl({ scope, parent, address, hasLocalName, isUpdate, disabled, onChange }: {
  scope: string
  parent: string
  address?: string
  hasLocalName: boolean
  isUpdate?: boolean
  disabled?: boolean
  onChange: (enabled: boolean) => void
}) {
  const validation = useNameScopeValidation(isUpdate ? '' : scope)
  return (
    <div className="my-2 w-full text-sm" data-md-contract="name-scope">
      {isUpdate ? <p>Inside @{scope}</p> : (
        <label className="flex items-center gap-2">
          <input type="checkbox" checked={!!scope} disabled={disabled} onChange={event => onChange(event.currentTarget.checked)} />
          <span>Inside @{parent}</span>
        </label>
      )}
      {!!scope && <>
        {!isUpdate && <p role="status">{validation.message}</p>}
        <p className="mt-1 text-xs text-gray-600">Enter a local name without @. The full address includes the parent.</p>
        {hasLocalName && <p className="mt-1 break-words" role="status">{address ? `Address: @${address}` : 'The full address must fit within 85 characters; the local name cannot contain @.'}</p>}
      </>}
    </div>
  )
}
